// Type definition for supported languages
export type Language = 'ja' | 'de';

// Default language setting
export const defaultLanguage: Language = 'ja';

/**
 * Retrieves translations for a specific key in the specified language
 * @param lang - Language code (ja/de)
 * @param key - Translation key (can be nested using dot notation)
 */
export async function getTranslation(lang: Language, key: string) {
  try {
    const response = await fetch(`/content/translations/${lang}.json`);
    if (!response.ok) {
      throw new Error(`Failed to load translations for ${lang}`);
    }
    const translations = await response.json();
    
    // Handle nested keys (e.g., 'nav.home')
    const keys = key.split('.');
    let value = translations;
    
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        return key;
      }
    }
    
    return value;
  } catch (error) {
    console.error('Error loading translations:', error);
    return key;
  }
}